var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDistrictDefaultIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.761 26.542h-8.898v32.079h8.898V26.542z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.136 59H14.5V26.163h9.636V59zm-8.898-.758h8.16v-31.32h-8.16v31.32z",
    fill: "#383838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.695 29.6h-2.54v2.564h2.54V29.6z",
    fill: "#EFEFF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.07 32.544H17.79v-3.31h3.279v3.31zm-2.54-.758h1.801v-1.82H18.53v1.82z",
    fill: "#383838"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.695 34.73h-2.54v2.564h2.54v-2.565z",
    fill: "#EFEFF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.07 37.673H17.79v-3.31h3.279v3.31zm-2.54-.745h1.801v-1.82H18.53v1.82z",
    fill: "#383838"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.695 39.871h-2.54v2.565h2.54v-2.565z",
    fill: "#EFEFF0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.07 42.802H17.79v-3.31h3.279v3.31zm-2.54-.745h1.801v-1.82H18.53v1.82z",
    fill: "#383838"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.695 45h-2.54v2.565h2.54v-2.564z",
    fill: "#EFEFF0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.07 47.945H17.79v-3.31h3.279v3.31zm-2.54-.758h1.801v-1.82H18.53v1.82z",
    fill: "#383838"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.695 50.13h-2.54v2.566h2.54V50.13z",
    fill: "#EFEFF0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.07 53.075H17.79v-3.31h3.279v3.31zm-2.54-.746h1.801v-1.82H18.53v1.82z",
    fill: "#383838"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.039 34.73H48.14v23.89h8.898V34.73z",
    fill: "#D9D9D9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.414 59h-9.637V34.363h9.637V59zm-8.898-.758h8.16V35.108h-8.16v23.134z",
    fill: "#383838"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.972 39.871h-2.54v2.565h2.54v-2.565z",
    fill: "#EFEFF0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.347 42.802h-3.279v-3.31h3.28v3.31zm-2.54-.745h1.802v-1.82h-1.802v1.82z",
    fill: "#383838"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.972 45h-2.54v2.566h2.54V45z",
    fill: "#EFEFF0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.347 47.945h-3.279v-3.31h3.28v3.31zm-2.54-.758h1.802v-1.82h-1.802v1.82z",
    fill: "#383838"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M53.972 50.13h-2.54v2.566h2.54V50.13z",
    fill: "#EFEFF0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54.347 53.074h-3.279v-3.31h3.28v3.31zm-2.54-.745h1.802v-1.82h-1.802v1.82z",
    fill: "#383838"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M43.584 12.366H28.328v3.563h15.256v-3.563z",
    fill: "#707070"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M43.96 16.308H27.952V12h15.994v4.308h.012zm-15.268-.758h14.517v-2.805H28.69v2.805z",
    fill: "#383838"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M48.14 15.93H23.762V58.62H48.14V15.929z",
    fill: "#8B8B8B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M48.515 59H23.398V15.55h25.117V59zm-24.378-.758h23.627V16.309H24.137v41.933z",
    fill: "#383838"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M39.78 50.13h-7.633v8.491h7.633v-8.49z",
    fill: "#EFEFF0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M40.144 59h-8.372v-9.236h8.372V59zm-7.634-.758h6.883V50.51H32.51v7.732z",
    fill: "#383838"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M36.326 50.13h-.738v8.491h.738v-8.49zM44.849 19.947H27.053v.746h17.796v-.746zM44.849 23.8H27.053v.746h17.796V23.8zM44.849 27.654H27.053v.745h17.796v-.745zM44.849 31.508H27.053v.745h17.796v-.745zM44.849 35.361H27.053v.745h17.796v-.745zM44.849 39.202H27.053v.745h17.796v-.745zM44.849 43.055H27.053v.746h17.796v-.746zM44.849 46.909H27.053v.745h17.796v-.745zM29.668 50.762h-2.615v.746h2.615v-.746zM44.862 50.762h-2.616v.746h2.616v-.746z",
    fill: "#383838"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistrictDefaultIcon);
export default __webpack_public_path__ + "static/media/district_default_icon.af0b2973dacedb18dcbf7af4222dca55.svg";
export { ForwardRef as ReactComponent };